import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../../../shared/LanguageService';
import {
    Button,
    Radio,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    HelpBlock,
    Media,
    Panel,
    Row,
    OverlayTrigger,
    Tooltip,
    Checkbox
} from 'react-bootstrap';
import CheckboxInput from '../../../../components/common/CheckboxInput';
import InlineTooltip from '../../../../components/common/ToolTip';

interface IScandphotosCreateOrderProductPageProps {
    products: any[];
    onPackageChange: (id: number) => void;
    onPackageAdditionChange: (id: number) => void;
    selectedProduct: any;
    selectedAdditionalProducts: number[];
}

class ScandphotosCreateOrderProductPage extends React.Component<
    IScandphotosCreateOrderProductPageProps,
    any
> {
    private packageTypeId: number = 2;
    private packageAdditionTypeId: number = 3;

    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            selectedAdditionPackagesMap: {}
        };
    }

    render() {
        let anyRequiredPackageProduct =
            this.props.products.filter((x) => {
                return !x.isPackageAddition && !x.isAddition && x.required;
            }).length > 0;
        return (
            <fieldset>
                <Col xs={12} md={6}>
                    <FormGroup className="required">
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-product/label/package'
                            )}
                        </ControlLabel>
                        {this.props.products
                            .filter((x) => {
                                return !x.isPackageAddition && !x.isAddition;
                            })
                            .map((pkg, index) => {
                                return (
                                    <Radio
                                        className="select-product"
                                        key={`product${index}`}
                                        disabled={anyRequiredPackageProduct}
                                        checked={pkg.id === this.props.selectedProduct}
                                        onChange={() => {
                                            this.props.onPackageChange(pkg.id);
                                        }}
                                    >
                                        <Media
                                            className={
                                                'product-box photo' +
                                                (pkg.required ? ' required' : '') +
                                                (!pkg.required && anyRequiredPackageProduct
                                                    ? ' disabled'
                                                    : '')
                                            }
                                        >
                                            <Media.Left align="middle">
                                                <i className="material-icons">add_a_photo</i>
                                            </Media.Left>
                                            <Media.Body>
                                                <h5>{pkg.name}</h5>
                                                <InlineTooltip
                                                    id={pkg.id}
                                                    tooltip={pkg.extraText}
                                                />
                                            </Media.Body>
                                        </Media>
                                    </Radio>
                                );
                            })}
                    </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-product/label/additions'
                            )}
                        </ControlLabel>
                        {this.props.products
                            .filter((x) => {
                                return x.isPackageAddition;
                            })
                            .map((pkg, index) => {
                                return (
                                    <Checkbox
                                        className="select-product"
                                        key={`product-addition${index}`}
                                        disabled={pkg.required}
                                        checked={
                                            this.props.selectedAdditionalProducts.indexOf(pkg.id) >=
                                            0
                                        }
                                        onChange={() => {
                                            this.props.onPackageAdditionChange(pkg.id);
                                        }}
                                    >
                                        <Media
                                            className={
                                                'product-box extras' +
                                                (pkg.required ? ' required' : '')
                                            }
                                        >
                                            <Media.Left align="middle">
                                                <i className="material-icons">add_circle_outline</i>
                                            </Media.Left>
                                            <Media.Body>
                                                <h5>{pkg.name}</h5>
                                                <InlineTooltip
                                                    id={pkg.id}
                                                    tooltip={pkg.extraText}
                                                />
                                            </Media.Body>
                                        </Media>
                                    </Checkbox>
                                );
                            })}
                    </FormGroup>
                </Col>
            </fieldset>
        );
    }
}
export default ScandphotosCreateOrderProductPage;

{
    /*<OverlayTrigger overlay={<Tooltip id={pkg.id}>{pkg.extraText}</Tooltip>} placement="top" delayShow={300} delayHide={150}></OverlayTrigger>*/
}
